module.exports = __webpack_public_path__ + "media/images/ico-subscribe-25de7e405a6504d0c8ff87c451e919c1.svg";